<template>
    <div :class="classes">
        <ul class="Utility__list-inline">
            <li>
                <a href="#" title="Export to PDF" @click.prevent="exportDashboard">
                    <i class="fa fa-file-pdf-o" aria-hidden="true"></i>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                csrfToken: Laravel.csrfToken,
                action: '',
            }
        },

        props: {
            isStatbox: {
                type: Boolean,
                default: false,
            }
        },

        computed: {
            classes() {
                return {
                    'Exporter': true,
                    'Exporter--with-clickable-title': true,
                    'Exporter--in-statbox': this.isStatbox,
                }
            }
        },

        methods: {
            exportDashboard() {
                bus.$emit('export-dashboard')
            }
        }
    }
</script>